import React from 'react';
import { Trans } from '@lingui/macro';
import { OrderDepth as OMSOrderDepth } from '@oms/components-order-depth';
import { useCustomerByToken } from 'client/customers';
import { ModuleSection, ModuleHeading, ModuleProps } from 'components/Module';

export default function OrderDepth({
  token,
  standalone = true,
  ...styleProps
}: ModuleProps) {
  const data = useCustomerByToken(token);
  if (!data?.itemSector) return null;
  return (
    <ModuleSection {...styleProps}>
      {standalone ? null : (
        <ModuleHeading>
          <Trans>Order depth</Trans>
        </ModuleHeading>
      )}
      <OMSOrderDepth
        itemSector={data?.itemSector}
        spec={{ auth: `key=${token}`, product: 'orderDepth' }}
      />
    </ModuleSection>
  );
}

export { OrderDepth };
